export default __webpack_public_path__ + "static/media/yardi_logo.517f740c.png";